<template>
	<FieldWrapper v-bind="wrapper">
		<input ref="field" v-bind="bind" v-model="model" />
	</FieldWrapper>
</template>

<script>
import FieldWrapper from '@/components/FieldWrapper'
import field from '@/mixins/field'

export default {
	name: 'FieldInput',
	mixins: [field],
	components: {
		FieldWrapper,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
input {
	@extend %field;
}
</style>
